import { HttpClient } from '../../../httpClient'
import { OpalApi } from '../../../schema'

type CreateBlockConnectorV3 = OpalApi<'CreateBlockConnectorV3', 201>

export const createBlockConnector: CreateBlockConnectorV3 = async (
  args = {}
) => {
  const url = new URL('/loupe/v3/block_connectors', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
